import { Menubar } from "primereact/menubar";
import { useNavigate } from "react-router-dom";
import c2sLogo from "../../assets/C2Slogo.png";
import { useMsal } from "@azure/msal-react";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "../../store/slices/userSlice";
import "./header.css";

export const Header = ({ toggleSideNav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const menuRef = useRef(null);
  const [userType, setUserType] = useState(
    () => localStorage.getItem("userType") || ""
  );
  const { userData } = useSelector((state) => state?.user);
  const userTypeRole = userData?.userTypes?.find((type) =>
    type?.userType?.toLowerCase().includes(userType?.toLowerCase())
  );
  const isSuperAdmin = userTypeRole?.userTypeRoleId === 1;
  const isHROrAccounts = [2, 3].includes(userTypeRole?.userTypeRoleId);

  const handleSwitchUserType = async () => {
    try {
      const newType = userType === "internal" ? "external" : "internal";
      const userTypeId = newType === "internal" ? 1 : 2;
      localStorage.setItem("userType", newType);
      localStorage.setItem("userTypeId", userTypeId);
      setUserType(newType);

      await dispatch(fetchUserData(userTypeId)).unwrap();

      // Find the role for the switched user type
      const switchedRole = userData?.userTypes?.find(
        (type) => type.userTypeId === userTypeId
      );
      sessionStorage.removeItem("hasClicked");
      // Navigate based on the switched role
      if (switchedRole?.userTypeRoleId === 1) {
        navigate("/admin/timesheet-list");
      } else if ([3].includes(switchedRole?.userTypeRoleId)) {
        navigate("/user/employees/timesheets");
      } else if ([2].includes(switchedRole?.userTypeRoleId)) {   navigate("/hr/employees/timesheets");} else {
        navigate("/user/timesheet");
      }
    } catch (error) {
      console.error("Error switching user type:", error);
    }
  };

  const start = (
    <div className="profile-section">
      <button className="hamburger pb-1" onClick={toggleSideNav}>
        ☰
      </button>{" "}
      <img src={c2sLogo} alt="C2S Technologies" className="logo" />
    </div>
  );

  const userMenuItems =
    userData?.userTypes?.length > 1
      ? [
          {
            label:
              "Switch to " +
              (userType === "internal"
                ? "External Projects"
                : "Internal Projects"),
            icon: "pi pi-sync",
            command: handleSwitchUserType,
          },
          {
            separator: true,
          },
          {
            label: "Logout",
            icon: "pi pi-sign-out",
            command: () => {
              localStorage.clear();
              sessionStorage.removeItem("hasClicked");
              instance.logoutRedirect({
                postLogoutRedirectUri: "/",
                account: accounts[0],
              });
              navigate("/");
            },
          },
        ]
      : [
          {
            label: "Logout",
            icon: "pi pi-sign-out",
            command: () => {
              localStorage.clear();
              instance.logoutRedirect({
                postLogoutRedirectUri: "/",
                account: accounts[0],
              });
            },
          },
        ];

  const currentUserType = userData?.userTypes?.find((type) =>
    type?.userType?.toLowerCase().includes(userType.toLowerCase())
  );

  const end = (
    <div className="grid justify-content-end align-items-center">
      <div className="col-12 md:col-6 lg:col-5 xl:col-4 xxl:col-3 flex-order-2 md:flex-order-0">
        {userData?.userTypes?.length > 1 && (
          <div className="user-type-badge">
            <i
              className={`pi ${
                userType === "internal" ? "pi-user" : "pi-users"
              }`}
            />
            <span>
              {userType === "internal"
                ? isSuperAdmin || isHROrAccounts ? "Internal" : "Internal Projects"
                : "External Projects"}
            </span>
          </div>
        )}
      </div>
      <div className="col-12 md:col-6 lg:col-6 xl:col-5 xxl:col-3">
        <div className="flex align-items-center justify-content-end">
          <Avatar
            label={
              userData?.userName?.charAt(0) ||
              accounts[0]?.name?.charAt(0) ||
              "U"
            }
            className="mr-2"
            shape="circle"
            style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
          />
          <div
            className="user-menu-trigger"
            onClick={(e) => menuRef.current.toggle(e)}
          >
            <span>
              <div className="user-name">
                {(userData?.userName || accounts[0]?.name || "User")
                  ?.toLowerCase()
                  ?.replace(/\b\w/g, (char) => char?.toUpperCase())}
              </div>
              <div className="user-role">
                {currentUserType?.userRole || "N/A"}
              </div>
            </span>

            <i className="pi pi-chevron-down" />
          </div>
        </div>

        {/* </div>
      <div className="col-6 md:col-5"> */}
      </div>
      <Menu model={userMenuItems} popup ref={menuRef} className="user-menu" />
    </div>
  );

  return (
    <div className="header">
      <div className="container">
        <div className="start">{start}</div>
        <div className="end">{end}</div>
      </div>
    </div>
  );
};
{
  /* <Menubar
start={start}
end={end}
className="nav-header"
/> */
}

//TODO: to be deleted after testing.
{
  /* <Menubar
start={start}
end={end}
className="nav-header"
/> */
}
